export const colorLog = (color: string, ...text: Array<string | object>) => {
  // eslint-disable-next-line no-console
  console.log('%c ', `background-color:${color}`, ...text)
}
